import { combineReducers } from '@reduxjs/toolkit';

import announcementsReducer from './announcements/announcementsSlice.js';
import authReducer from './auth/authSlice.js';
import balanceReducer from './balance/balanceSlice.js';
import billingReducer from './billing/billingSlice.js';
import coloReducer from './colo/coloSlice.js';
import configReducer from './config/config.reducer.js';
import contractsReducer from './contracts/contractsSlice.js';
import customerReducer from './customer/customerSlice.js';
import equipmentReducer from './equipment/equipmentSlice.js';
import exchangeRateReducer from './exchangeRate/exchangeRateSlice.js';
import featuresReducer from './features/featuresSlice.js';
import insightsReducer from './insights/insightsSlice.js';
import locationsReducer from './locations/locationsSlice.js';
import locationsCalculationsReducer from './locationsCalculations/locationsCalculationsSlice.js';
import minerReducer from './miner/miner.reducer.js';
import mollieReducer from './mollie/mollieSlice.js';
import notificationsReducer from './notifications/notifications.reducer.js';
import orderReducer from './order/orderSlice.js';
import poolReducer from './pool/poolSlice.js';
import priceGroupReducer from './priceGroup/priceGroupSlice.js';
import productsReducer from './products/productsSlice.js';
import stripeReducer from './stripe/stripeSlice.js';
import tasksReducer from './tasks/tasksSlice.js';
import tenantsReducer from './tenants/tenantsSlice.js';
import transactionsReducer from './transactions/transactionsSlice.js';
import watcherLinksReducer from './watcherLinks/watcherLinksSlice.js';

const reducer = combineReducers({
  announcements: announcementsReducer,
  auth: authReducer,
  billing: billingReducer,
  balance: balanceReducer,
  colo: coloReducer,
  config: configReducer,
  contracts: contractsReducer,
  customer: customerReducer,
  equipment: equipmentReducer,
  exchangeRate: exchangeRateReducer,
  features: featuresReducer,
  insights: insightsReducer,
  locations: locationsReducer,
  miner: minerReducer,
  mollie: mollieReducer,
  notifications: notificationsReducer,
  order: orderReducer,
  pool: poolReducer,
  priceGroup: priceGroupReducer,
  products: productsReducer,
  stripe: stripeReducer,
  tasks: tasksReducer,
  tenants: tenantsReducer,
  transactions: transactionsReducer,
  watcherLinks: watcherLinksReducer,
  locationsCalculations: locationsCalculationsReducer
});

export default reducer;
